module.exports = __webpack_public_path__ + "static/media/goblin_axeman_head.55f8a458.svg";